import * as React from "react"

interface State {
  error: any
}
class ErrorHandler extends React.Component {
  state: State = { error: null }

  componentDidCatch(error: any) {
    this.setState({ error })
  }

  render() {
    if (this.state.error) {
      // Render fallback UI
      return (
        <div style={{ padding: 30 }}>
          <p>
            Sorry{" "}
            <span role="img" aria-label="emoji">
              😳{" "}
            </span>
            Looks like something went wrong.
          </p>
          <p>Please refresh the app.</p>
        </div>
      )
    } else {
      // When there's not an error, render the children untouched
      return this.props.children
    }
  }
}

export default ErrorHandler



// WEBPACK FOOTER //
// ./src/components/app-error-boundary/app-error-boundary.component.tsx